import { ClientFulfillmentGroupFolder } from "@redotech/redo-model/views/folders";
import { ClientFulfillmentGroupView } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";
import { null as zNull } from "zod/v4";
export const getViewsAndFolders = {
  name: "getViewsAndFolders" as const,
  input: zNull(),
  output: z.object({
    folders: z.array(ClientFulfillmentGroupFolder),
    views: z.array(ClientFulfillmentGroupView),
  }),
};
